export const APP_ROUTES = {
  homePage: "/",
  aboutPage: "/about",
  introducingPage: "/introducing",
  jobOpportunitiesPage: "/job-opportunities",
  jobOpportunitiesInfo: "/job-opportunities/:id",
};
